/** Shared by every create flow that turns free text into a repo-safe slug —
 * see CreateFlowPage.tsx and CreateAiAgentPage.tsx. */
export function sanitizeName(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** The inverse of sanitizeName, for display only — "customer-support" ->
 * "Customer Support". Used to show a department/repo slug back to a human
 * without a second, separate display-name field to keep in sync. */
export function humanizeSlug(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
